import React from 'react'
import { 
  getUniqueLetters,
  getUsableLetters,
  checkLetters,
  isNewWord,
  getTime,
  setTheme
} from './helpers'
import './App.css'
import Words from './Words'
import PlayerTimer from './PlayerTimer'
import WelcomeScreen from './WelcomeScreen'
import text from './languages'
import themes from './themes'

class App extends React.Component {
  state = {
    mainWord: '',
    uniqueLetters: [],
    letters: [],
    wordsList: [],
    isFirstPlayerTurn: true,
    timerDefault: 45,
    timer: 45,
    lives: [5, 5],
    startLives: 5,
    wordsLang: "ru",
    langUI: "ru",
    theme: 'dark',
    gameFinished: false,
    gamePaused: false
  }
  
  timer = null

  componentDidMount() {
    document.body.addEventListener('keydown', this.onKeyDown)
    setTheme({ themes, theme: this.state.theme })
  }

  componentWillUnmount() {
    document.body.removeEventListener('keydown', this.onKeyDown)
  }

  render() {
    return (
      <div className="container">
        <div className="select-theme">
          <i 
            className="fas fa-sun"
            onClick={() => {
              this.setState({ theme: 'light'})
              setTheme({ themes, theme: 'light' })
            }}
          ></i>
          <i 
            className="far fa-moon"
            onClick={() => {
              this.setState({ theme: 'dark'})
              setTheme({ themes, theme: 'dark' })
            }}
          ></i>
        </div>
        <div className="select-ui-lang">
          <img 
            className="flag ru" 
            src="https://www.countryflags.io/ru/flat/32.png"
            alt="Русский"
            title="Русский" 
            onClick={() => this.setState({ langUI: "ru" })}
          />
          <img 
            className="flag en" 
            src="https://www.countryflags.io/gb/flat/32.png"
            alt="English"
            title="English" 
            onClick={() => this.setState({ langUI: "en" })}
          />
        </div>
        <div className="game">
          {this.renderMainWord()}
          <Words 
            wordsList={this.state.wordsList}
            uniqueLetters={this.state.uniqueLetters}
            isGamePaused={this.state.gamePaused}
            wordsLang={this.state.wordsLang}
            langUI={this.state.langUI}
          >
            {this.renderWelcomeScreen()}
            {this.renderPauseScreen()}

          </Words>
          <div className="footer">
            {this.renderFooter()}
          </div>
        </div>
      </div>
    )
  }

  //#region Renderers
  renderSetWord = () => {
    return (
      <div className="set-word">
        <input 
          type="text"
          placeholder={text.APP_BASEWORD[this.state.langUI]}
          onKeyPress={this.onSetWordSubmit}
          autoFocus
        ></input>
      </div>
    )
  }

  renderWelcomeScreen = () => {
    if (!this.state.mainWord) {
      return (
        <WelcomeScreen
          timer={this.state.timerDefault}
          lives={this.state.startLives}
          setTimerLength={this.setTimerLength}
          setLivesAmount={this.setLivesAmount}
          setWordsLang={this.setWordsLang}
          wordsLang={this.state.wordsLang}
          langUI={this.state.langUI}
        >
          {this.renderSetWord()}
        </WelcomeScreen>
      )
    }
  }

  renderPauseScreen = () => {
    if (this.state.gamePaused) {
      return (
        <div className="pause">
          {text.APP_PAUSE_1[this.state.langUI]} <nobr>Alt + P</nobr> {text.APP_PAUSE_2[this.state.langUI]}
        </div>
      )
    }
  }

  renderMainWord = () => {
    if (!this.state.gamePaused) {
      return (
        <div className="header">
            <h1 className="main-word">
              {this.state.mainWord}
            </h1>
          </div>
      )
    }
  }

  renderFooter = () => {
    if (!this.state.mainWord) {
      return (
        <div className="footer-info">
          <a href="https://github.com/eXConf">© eXConf</a>
        </div>
      )
    } else {
      return (
        <div className="word-input">
          <PlayerTimer 
            player={0}
            time={getTime(this.state.timer)} 
            active={this.state.isFirstPlayerTurn}
            startLives={this.state.startLives}
            lives={this.state.lives[0]} 
          />
          {this.renderWordInput()}
          <PlayerTimer 
            player={1}
            time={getTime(this.state.timer)} 
            active={!this.state.isFirstPlayerTurn}
            startLives={this.state.startLives}
            lives={this.state.lives[1]} 
          />
        </div>
      )
    }
  }

  renderWordInput = () => {
    return (
      <input 
        type="text"
        placeholder={text.APP_WORD_INPUT[this.state.langUI]}
        onKeyPress={this.onWordSubmit}
        autoFocus
      />
    )
  }
//#endregion

  startGame = () => {
    const { timerDefault, startLives } = this.state
    this.stopTimer(this.timer)
    this.setState({
      isFirstPlayerTurn: true,
      timer: timerDefault,
      lives: [startLives, startLives],
      gameFinished: false
    })
  }

  switchTurn = () => {
    const turn = !this.state.isFirstPlayerTurn
    this.setState({isFirstPlayerTurn: turn})
  }

  stopTimer = (timer) => {
    if (timer) {
      clearInterval(timer)
    }
  }

  resetTimer = () => {
    this.setState({timer: this.state.timerDefault})
  }

  runTimer = async () => {
    this.stopTimer(this.timer)
    this.timer = setInterval(() => {
      const newTime = this.state.timer - 1
      this.setState({timer: newTime})
      if (newTime === 0) {
        this.onTimerEnd()
      }
    }, 1000)
  }

  setTimerLength = (seconds) => {
    this.setState({ timerDefault: parseInt(seconds) })
  }

  setLivesAmount = (lives) => {
    this.setState({ startLives: parseInt(lives) })
  }

  setGameFinished = () => {
    this.setState({ gameFinished: true })
  }

  setWordsLang = (lang) => {
    this.setState({ wordsLang: lang })
  }

  undoTurn = () => {
    const newWordsList = [...this.state.wordsList]
      if (newWordsList.length > 0) {
        newWordsList.pop()
        this.setState({ wordsList: [...newWordsList] })
        this.switchTurn()
        this.resetTimer()
        this.runTimer()
        alert(text.APP_ALERT_UNDO[this.state.langUI])
      }
  }

  switchPause = () => {
    if (!this.state.gamePaused && this.state.mainWord) {
      this.setState({ gamePaused: true })
      this.stopTimer(this.timer)
    } else {
      this.setState({ gamePaused: false })
      this.runTimer()
    }
  }

  isPlayerLost = () => {
    const { lives } = this.state
    let isPlayerLost = false
    if (lives[0] === 0 || lives[1] === 0) {
      isPlayerLost = true 
    }
    return isPlayerLost
  }

  onSetWordSubmit = (e) => {
    if (e.key === 'Enter') {
      this.startGame()
      const word = e.target.value.toUpperCase()
      const letters = word.split('')
      const usableLetters = getUsableLetters(letters)
      const uniqueLetters = getUniqueLetters(usableLetters)
      this.setState({
        mainWord: word, 
        letters: letters,
        uniqueLetters: uniqueLetters,
        wordsList: []
      })
      e.target.value = ''
      e.target.blur()
    }
  }

  onWordSubmit = (e) => {
    if (this.state.gamePaused) {
      e.preventDefault()
      return
    }
    if (e.key === 'Enter') {
      if (!e.target.value || this.state.gameFinished) {
        return
      }
      const word = e.target.value.toUpperCase()
      const wordsList = [...this.state.wordsList]
      const letters = [...this.state.letters]
      const wrongLetter = checkLetters({word, letters})
      const newWord = isNewWord({ word, wordsList })
      if (newWord && wrongLetter === '') {
        wordsList.push(word)
        this.setState({wordsList: wordsList})
        e.target.value = ''
        this.resetTimer()
        this.runTimer()
        this.switchTurn()
      } else if (!newWord) {
        alert(`${text.APP_ALERT_NOT_NEW_WORD[this.state.langUI]}`)
      } else if (wrongLetter !== '') {
        alert(`${text.APP_ALERT_NO_SUCH_LETTER[this.state.langUI]} '${wrongLetter}'`)
      }
    }
  }

  onKeyDown = (e) => {
    if (e.keyCode === 90 && e.ctrlKey) {
      e.preventDefault()
      this.undoTurn()
    } else if (e.altKey && e.keyCode === 80) {
      this.switchPause()
    }
  }

  onTimerEnd = () => {
    this.stopTimer()    
    const player = this.state.isFirstPlayerTurn ? 0 : 1
    const lives = [...this.state.lives]
    lives[player] -= 1
    this.setState({ lives: lives })
    
    if (!this.isPlayerLost()) {
      this.switchTurn()
      alert(`${text.APP_ALERT_TIMEOUT[this.state.langUI]} ${player === 0 ? 2 : 1}`)
      this.resetTimer()
      this.runTimer()
    } else {
      this.onPlayerLost()
    }
  }

  onPlayerLost = () => {
    const player = this.state.isFirstPlayerTurn ? 2 : 1
    this.stopTimer()
    this.setGameFinished()
    alert(`${text.APP_ALERT_GAMEOVER_1[this.state.langUI]} ${player} ${text.APP_ALERT_GAMEOVER_2[this.state.langUI]}`)
  }
}

export default App